module.exports = __webpack_public_path__ + "static/media/pypi.73304a42.png";